import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Caution = makeShortcode("Caution");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "migration-notes"
    }}><a parentName="h2" {...{
        "href": "#migration-notes"
      }}>{`Migration notes`}</a></h2>
    <Caution mdxType="Caution">
      <p>{`If your organization's SSO was set up before April 2024, you must create a new SSO configuration with the `}<a parentName="p" {...{
          "href": "#setup"
        }}>{`updated instructions`}</a>{` before November 15, 2024. After November 15, 2024, the legacy configuration will no longer work, and your organization will lose access to GraphOS if you haven't created a new configuration.`}</p>
    </Caution>
    <p>{`To migrate from a legacy configuration, a GraphOS `}<a parentName="p" {...{
        "href": "/graphos/org/members/#organization-wide-member-roles"
      }}>{`Org Admin`}</a>{` must create a new SSO configuration.
You can create a new configuration while the legacy configuration continues to provide SSO for your organization.`}</p>
    <p>{`The GraphOS setup wizard takes you through the configuration process, step-by-step.
It won't let you activate your new configuration until it has confirmed that you're able to sign in with it.`}</p>
    <img src="/5075de3398b0b5efa1a5ad5a0be46ce7/sso-verification.jpg" alt="SSO Setup Wizard showing the verification step in GraphOS Studio" className="screenshot" width="600" />
    <p>{`Once the new configuration is verified and active, you should remove any legacy configurations from your IdP.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      